/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  addPlace: (data) => {
    return axios.post(API_ENDPOINTS.GET_PLACES_LIST, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deletePlaceById: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_PLACES_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getPlaceById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_PLACES_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  updatePlaceById: (id, data) => {
    return axios.put(`${API_ENDPOINTS.GET_PLACES_LIST}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getPlaceList: (params) => {
    return axios.get(API_ENDPOINTS.GET_PLACES_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
};
